// Mount the front-page Advanced search box (no-op on pages without the island).
import { Islands } from "@brave-new-world/shared";
import { mountIsland } from "../../ui/islands";
import { FrontAdvanced } from "./FrontAdvanced";

export function initFrontAdvanced(): void {
  mountIsland(Islands.frontAdvanced, FrontAdvanced, {});
}
